import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const workload = createReducer({}, (builder) => {
  builder.addCase(actionTypes.WORKLOAD_TOGGLE_COMPLETED_TASKS, (state, action) => {
    const { userId, toggle } = action;
    if (userId) {
      return { ...state, [userId]: toggle };
    }
    return state;
  });
});

export default workload;
